<template>
	<div>
		<div v-if="warn_compa">
			<div align="center" class="mt-5">
				<br /><br />
				<v-icon size="70" color="primary">mdi-emoticon-sad-outline</v-icon>
				<h1>¡Ups!</h1>
				<p>Tecnologia no compatible</p>
				<p>Apple aún no ha desarrollado la compatibilidad con Push Notifications.</p>
			</div>
		</div>
		<div v-else>
			<v-list subheader three-line flat>
				<v-subheader>Notificaciones WEB</v-subheader>

				<v-list-item-group>
					<!-- ACADEMICAS -->
					<v-list-item :disabled="!push_active">
						<template v-slot:default>
							<v-list-item-action>
								<v-checkbox
									v-model="conf_push.academico"
									color="primary"
								></v-checkbox>
							</v-list-item-action>

							<v-list-item-content>
								<v-list-item-title>Académicos</v-list-item-title>
								<v-list-item-subtitle
									>Recibe notificaciones sobre anuncios
									académicos.</v-list-item-subtitle
								>
							</v-list-item-content>
						</template>
					</v-list-item>

					<!-- administrativas -->
					<v-list-item :disabled="!push_active">
						<template v-slot:default>
							<v-list-item-action>
								<v-checkbox
									v-model="conf_push.administrativo"
									color="primary"
								></v-checkbox>
							</v-list-item-action>

							<v-list-item-content>
								<v-list-item-title>Administrativos</v-list-item-title>
								<v-list-item-subtitle
									>Recibe notificaciones sobre anuncios
									administrativos.</v-list-item-subtitle
								>
							</v-list-item-content>
						</template>
					</v-list-item>

					<!-- Carrera - ING -->
					<v-list-item :disabled="!push_active">
						<template v-slot:default>
							<v-list-item-action>
								<v-checkbox
									v-model="conf_push.carrera"
									color="primary"
								></v-checkbox>
							</v-list-item-action>

							<v-list-item-content>
								<v-list-item-title>Ingeniería</v-list-item-title>
								<v-list-item-subtitle
									>Recibe notificaciones sobre anuncios de la carrera y el Centro
									de Estudiantes.</v-list-item-subtitle
								>
							</v-list-item-content>
						</template>
					</v-list-item>
				</v-list-item-group>
			</v-list>

			<v-container>
				<v-row>
					<v-col cols="12">
						<v-btn
							color="primary"
							block
							@click="guardarCambios"
							:loading="btn_loading"
							:disabled="btn_loading || !push_active"
							>Guardar cambios</v-btn
						>
					</v-col>
					<v-col cols="12">
						<v-btn outlined block @click="suscribir">
							<v-icon>mdi-cellphone-link</v-icon> Suscribir este dispositivo</v-btn
						>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<!-- LOADING -->
		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>

		<!-- WAITING -->
		<v-snackbar bottom :color="msj.color" v-model="msj_snack" :timeout="3000">
			{{ msj.text }}

			<v-btn dark text @click="msj_snack = false" :to="{ name: 'Inicio' }">
				Volver
			</v-btn>
		</v-snackbar>
	</div>
</template>

<script>
import store from "../store/index";
import { CONFIG_API } from "../apiConfig";
import { sendTopics, messaging, fb_mss } from "../firebase";
import { getDataModule, setDataModule } from "../db_save";

export default {
	data: () => ({
		warn_compa: false,
		loading: true,
		btn_loading: false,
		msj_snack: false,
		msj: { color: "", text: "" },
		push_active: true,
		token: "",
		conf_push: {
			academico: false,
			administrativo: false,
			carrera: false
		}
	}),
	created() {
		store.commit("toggleTabs", false);
		if (fb_mss.isSupported()) {
			//Cargando config
			if ("Notification" in window) {
				messaging
					.getToken()
					.then(currentToken => {
						if (currentToken) {
							this.push_active = true;
							this.token = currentToken;

							//console.log("token2: ", currentToken);

							getDataModule("config", 15 * 60 * 1000, CONFIG_API + `/${currentToken}`)
								.then(configuracion => {
									//console.log("Config Obtenida ", configuracion);
									if (configuracion.topics) {
										//Tiene topics suscriptos

										if (configuracion.topics.administrativo) {
											this.conf_push.administrativo = true;
										}
										if (configuracion.topics.academico) {
											this.conf_push.academico = true;
										}
										if (configuracion.topics.carrera) {
											this.conf_push.carrera = true;
										}
									}
								})
								.catch(err => {
									console.error("Algo paso: ", err);
									this.msj.color = "error";
									this.msj.text = "Error de conexión";
									this.msj_snack = true;
								});
						}
					})
					.catch(err => {
						this.push_active = false;
						//Negado token
						console.error("Error con token ", err);
					})
					.finally(() => {
						this.loading = false;
					});
			} else {
				//No compatibilidad PushNoti
				this.warn_compa = true;
			}
		} else {
			//No compatibilidad PushNoti
			this.warn_compa = true;
		}
	},
	methods: {
		guardarCambios() {
			//console.warn("Guardando");
			let objPref = this.conf_push;
			objPref.token = this.token;
			this.btn_loading = true;

			sendTopics(objPref)
				.then(() => {
					let auxTopic = {};

					if (this.conf_push.administrativo) {
						auxTopic["administrativo"] = true;
						this.$ua.trackEvent(`CplusInteraccion`, "ChangeSus", "administrativo true");
					}
					if (this.conf_push.academico) {
						auxTopic["academico"] = true;
						this.$ua.trackEvent(`CplusInteraccion`, "ChangeSus", "academico true");
					}
					if (this.conf_push.carrera) {
						auxTopic["carrera"] = true;
						this.$ua.trackEvent(`CplusInteraccion`, "ChangeSus", "carrera true");
					}

					let topics = { topics: auxTopic };

					setDataModule("config", topics);

					this.msj.color = "primary";
					this.msj.text = "¡Cambios guardados!";
					this.msj_snack = true;
				})
				.catch(err => {
					console.error("Algo paso al guardar: ", err);
					this.msj.color = "error";
					this.msj.text = "Error de conexión";
					this.msj_snack = true;
				})
				.finally(() => {
					this.btn_loading = false;
				});
		},
		suscribir() {
			if ("Notification" in window) {
				//console.warn("PERMISO ", Notification.permission);
				messaging
					.getToken()
					.then(currentToken => {
						//console.warn("TOKEN FB: ", currentToken);
						if (currentToken) {
							sendTopics({
								academico: true,
								administrativo: true,
								carrera: true,
								token: currentToken
							});

							let topics = {
								topics: {
									academico: true,
									administrativo: true,
									carrera: true
								}
							};
							setDataModule("config", topics);

							this.$ua.trackEvent(`CplusInteraccion`, "Suscribirse", "ThisAll");
						}

						this.$router.push({ name: "Inicio" });
					})
					.catch(err => {
						this.msj.color = "info";
						this.msj.text = "Habilita las notificaciones en la barra de navegación";
						this.msj_snack = true;

						console.error("An error occurred while retrieving token. ", err);
					})
					.finally(() => {
						//this.$router.push({ name: "Inicio" });
					});
			}
		}
	}
};
</script>

<style></style>
